import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import { logout } from "./auth";
import { refreshAccessToken } from "./auth";
function Navbar() {
  const location = useLocation(); // current path
  const [user, setuser]=useState(null);
  const navigate = useNavigate();
  

  useEffect(() => {
      async function init() {
        const success = await refreshAccessToken();
        if (!success) {
          console.log('Refresh failed, redirected to login.');
          return;
        }
    console.log("Navbar useeffect");
        try {
          const res = await fetch('/me', { credentials: 'include' });
          console.log("res:",res);
          const raw_text = await res.text();
          console.log("Raw text", raw_text);
          const data = JSON.parse(raw_text);
          if (res.ok) {
            if (data.sicil_no) {
              //setFormData((prevData) => ({ ...prevData, SICIL_NO: data.SICIL_NO }));
              console.log("sicil_no: ", data.sicil_no);
              setuser(data);
              //fetchIzinler(data);
            } else {
              console.error("Sicil bilgisi bulunamadı");
            }
          } else {
            console.error("User fetch error:", data.error);
          }
        } catch (err) {
          console.error("User fetch exception:", err);
        }
      }
    
      init();
    }, []);
    /*
  useEffect(() => {
    if (user==null) {
      console.error("Kullanıcı bulunamadı (Navbar)");
      navigate("/Login"); // Kullanıcı yoksa->Redirect to login 
    }
      console.log("User registered (Navbar).")
    }, []);
*/
  

  const handleLogout = () => {
    
    //localStorage.removeItem("user");
    logout();
    navigate("/login",{replace:true});
  };

  return (
    <>
      <img src={`/logo.png`} alt="Logo" className="logo" />
      <nav className="navbar">
        <ul className="navbar-ul">
          <li className="navbar-li">
            <Link
              to="/izin_talep"
              className={`navbar-a ${location.pathname === "/izin_talep" ? "active" : ""}`}
            >
              İzin Talep
            </Link>
          </li>{user&&user.yonetici&&(
          <li className="navbar-li">
            <Link
              to="/izin_onay"
              className={`navbar-a ${location.pathname === "/izin_onay" ? "active" : ""}`}
            >
              İzin Onay
            </Link>
          </li>)}
          {/*{user&&[250, 16, 90, -1].includes(parseInt(user.sicil_no))&&(
          <li className="navbar-li">
            <Link
              to="/yonetim_panel"
              className={`navbar-a ${location.pathname === "/yonetim_panel" ? "active" : ""}`}
            >
              Yönetim Paneli
            </Link>
          </li>)}*/}
          {user&&[250, 16, 90, -1].includes(parseInt(user.sicil_no))&&(
          <li className="navbar-li">
            <Link
              to="/yonetim_izin_giris"
              className={`navbar-a ${location.pathname === "/yonetim_izin_giris" ? "active" : ""}`}
            >
              İK Yönetim Paneli
            </Link>
          </li>)}
          {user&&[250, 16, 90, -1].includes(parseInt(user.sicil_no))&&(
          <li className="navbar-li">
            <Link
              to="/toplu_izin"
              className={`navbar-a ${location.pathname === "/toplu_izin" ? "active" : ""}`}
            >
              Toplu İzin Girişi
            </Link>
          </li>)}
        </ul>
        {user&&(<div className="logout-container">
        <Link
              to="/kullanici_panel">
        <span className="user-name">{user.ad_soyad}</span>
        </Link>
        <button onClick={handleLogout} className="logout-button">Çıkış</button>
      </div>)}
      </nav>
    </>
  );
}

export default Navbar;
